/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcSuccessCircleFill({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M1.1 12C1.1 5.98 5.98 1.1 12 1.1S22.9 5.98 22.9 12 18.02 22.9 12 22.9 1.1 18.02 1.1 12m15.978-2.14a.9.9 0 1 0-1.268-1.276l-5.52 5.481-2.1-2.086a.9.9 0 0 0-1.27 1.277l2.736 2.716a.9.9 0 0 0 1.268 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcSuccessCircleFill;
